<template>
  <div class="stats">
    <div class="title row">
      <div class="grid-12">
        Estatísticas
        <strong>e insights</strong>
      </div>
      <!-- <div class="grid-2">
        <select class="filter">
          <option type="text">última semana</option>
          <option type="text">últimos 15 dias</option>
          <option type="text">ordenando por SLA</option>
        </select>
      </div>-->
    </div>

    <div
      class="column-s justify-space"
      :class="direction ? 'row horizontal align-center' : 'column vertical'"
    >
      <div class="data">
        <div class="number n1">
          {{
            stats.score_atual ? stats.score_atual.toString().replace(".", ",") : "5,00"
          }}
        </div>
        <div class="subtitle score-link" @click="modal.show = true">
          Score
          <i class="fa fa-external-link-alt"></i>
        </div>
      </div>
      <div class="data">
        <div class="number n1">{{ stats.jobs || 0 }}</div>
        <div class="subtitle">Jobs</div>
      </div>
      <div class="data">
        <div class="number n1">{{ stats.atendimentos || 0 }}</div>
        <div class="subtitle">Atendimentos</div>
      </div>
      <div class="data" v-if="user.perfil == 'doutor'">
        <div class="number n3">
          {{ stats.ganhos ? stats.ganhos.toLocaleString("pt-BR") : 0 }}
        </div>
        <div class="subtitle">Ganhos (R$)</div>
      </div>
    </div>
    <Modal :modal="modal" class="graph">
      <div class="title column align-center justify-center">
        <img src="../assets/img/NeTI.jpg" />
        Histórico Desempenho
      </div>
      <div class="row-g column content">
        <div class="score grid-6-g">
          <Chart :chartdata="chartdata" :options="options"></Chart>
        </div>
        <div class="how column grid-6-g">
          <h4>Como o seu score é determinado?</h4>
          - Cumprimento horários de atendimento <br />- Avaliações do cliente e gestor de
          demanda <br />- Cumprimento com as obrigações do portal
          <h4>Como posso melhorar ou manter um bom desempenho?</h4>
          - Desistir de um atendimento após ser selecionado prejudica o seu score.
          Portanto, se candidate a jobs que realmente tenha condições de atender <br />-
          Chegue no horário, realize um bom atendimento e cumpra coma as obrigações de
          atendimento no portal, informando deslocamento, realizando check-in e seu
          encerramento com dados corretos. Lembre-se que nosso aplicativo te ajuda com
          automação do registro de deslocamento e check-in se você interagir com ele 1
          hora antes de iniciar o atendimento.
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Modal from "@/components/Modal.vue";
import Chart from "@/components/Chart2.vue";

export default {
  name: "Stats",
  components: { Modal, Chart },
  data() {
    return {
      direction: true,
      modal: {
        show: false,
      },
      chartdata: {
        labels: ["Score atual", "Últimos 15 Jobs", "Últimos 5 Jobs", "Últimos 3 Jobs"],
        datasets: [],
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 5,
                stepSize: 1,
              },
            },
          ],
        },
      },
    };
  },
  methods: {
    ...mapActions("general", ["LOAD_STATS"]),
  },
  beforeMount() {
    var self = this;
    setTimeout(function () {
      self.direction = self.user.perfil == "agregado_doutor" ? false : true;
    }, 700);

    this.LOAD_STATS().then(() => {
      this.chartdata.datasets.push({
        label: "SCORE",
        backgroundColor: "transparent",
        borderColor: "#28BC9A",
        pointBackgroundColor: "white",
        borderWidth: 1,
        pointBorderColor: "#249EBF",
        data: [
          this.stats.score_atual,
          this.stats.score_ult_15,
          this.stats.score_ult_5,
          this.stats.score_ult_3,
        ],
      });
    });
  },
  computed: {
    ...mapGetters("general", ["stats"]),
    ...mapGetters("user", ["user"]),
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.stats {
  overflow-x: auto;
  background: $white;
  box-shadow: $shadow;
  border-radius: 23px;
  padding: 32px 35px;
  @media (max-width: 1530px) and (min-width: 900px) {
    /* height: 205px; */
  }

  @media (max-width: $small) {
    height: auto;
    margin-bottom: 30px;
  }

  .horizontal {
    height: 168px;
  }
  .vertical {
    height: 500px;
  }
  .score-link {
    &:hover {
      cursor: pointer;
      color: $blue-1;
    }
  }

  .graph {
    .title {
      padding: 0px 10px;
      text-align: center;
      margin-bottom: 20px;
      img {
        width: 65px;
        border-radius: 50%;
        margin-bottom: 10px;
      }
    }
    .content {
      padding: 20px 10px;
      padding-bottom: 15px;
      line-height: 1.7rem;
      font-size: 14px;
      text-align: justify;
      color: $gray-1;
    }

    & .modal-box {
      max-width: 90%;
    }
    /*   & .modal-box {
      max-width: 95%;
      @media (max-width: $large) {
        margin-left: 2%;
        left: 0px;
      }
      @media (min-width: $large) {
        max-width: $large;
      }
      @media (min-width: $large) {
        margin-left: -50%;
      }
    } */

    .how {
      @media (min-width: $large) {
        margin-left: 25px;
      }
    }
    h4 {
      color: $green-1;
    }
  }
  .title {
    font-size: 26px;
    font-weight: 400;
    margin-bottom: 5px;
  }
  .data {
    padding: 40px 20px;
    padding-top: 20px;
    padding-bottom: 30px;
    .number {
      font-size: 60px;
      color: $supporter-1;
      @media (max-width: $large) {
        font-size: 37px;
      }
      font-weight: 300;
      text-align: center;
      /* &.n1 {
        color: $green-4;
      } */
      /* &.n2 {
        color: $red-2;
      } */
      &.n3 {
        font-size: 65px;
        @media (max-width: $large) {
          font-size: 47px;
        }
        color: $supporter-1;
        span {
          font-size: 28px;
          margin-left: 3px;
        }
      }
    }
    .subtitle {
      text-align: center;
    }
  }
}
</style>
